import { assignmentIds } from './taskFilters.js'
export function dateValue(value) {
  if (!value) return ''
  const date = new Date(value)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}
export function taskDraft(task) {
  return { title: task.title, percentComplete: task.percentComplete ?? 0, priority: task.priority ?? 5, startDateTime: dateValue(task.startDateTime), dueDateTime: dateValue(task.dueDateTime), bucketId: task.bucketId, assignments: assignmentIds(task), appliedCategories: Object.keys(task.appliedCategories || {}).filter(key => task.appliedCategories[key] === true) }
}
export function taskChanges(task, draft) {
  const initial = taskDraft(task), result = {}
  for (const key of ['title', 'percentComplete', 'priority', 'bucketId']) if (initial[key] !== draft[key]) result[key] = draft[key]
  for (const key of ['startDateTime', 'dueDateTime']) if (initial[key] !== draft[key]) result[key] = draft[key] ? new Date(`${draft[key]}T00:00:00`).toISOString() : null
  const assignments = {}
  for (const id of initial.assignments) if (!draft.assignments.includes(id)) assignments[id] = null
  for (const id of draft.assignments) if (!initial.assignments.includes(id)) assignments[id] = { '@odata.type': 'microsoft.graph.plannerAssignment', orderHint: ' !' }
  if (Object.keys(assignments).length) result.assignments = assignments
  const categories = {}
  for (const key of new Set([...initial.appliedCategories, ...draft.appliedCategories])) if (initial.appliedCategories.includes(key) !== draft.appliedCategories.includes(key)) categories[key] = draft.appliedCategories.includes(key)
  if (Object.keys(categories).length) result.appliedCategories = categories
  return result
}
export function detailDraft(details) {
  return { notes: details.notes?.content || '', checklist: Object.entries(details.checklist || {}).filter(([id]) => !id.startsWith('@')).map(([id, item]) => ({ id, title: item.title, isChecked: item.isChecked })), references: Object.entries(details.references || {}).filter(([id]) => !id.startsWith('@')).map(([id, item]) => ({ id, alias: item.alias || '', url: decodeURIComponent(id) })) }
}
export function detailChanges(details, draft) {
  const initial = detailDraft(details), result = {}
  if (initial.notes !== draft.notes) result.notes = draft.notes
  for (const key of ['checklist', 'references']) {
    const patch = {}
    for (const item of initial[key]) if (!draft[key].some(next => next.id === item.id)) patch[item.id] = null
    for (const item of draft[key]) {
      const old = initial[key].find(old => old.id === item.id)
      if (key === 'checklist' && (!old || old.title !== item.title || old.isChecked !== item.isChecked)) patch[item.id] = { title: item.title, isChecked: item.isChecked }
      if (key === 'references' && (!old || old.alias !== item.alias || old.url !== item.url)) {
        const id = old?.url === item.url ? item.id : item.url.replace(/[.:%@#]/g, character => `%${character.charCodeAt(0).toString(16).toUpperCase()}`)
        if (old && id !== item.id) patch[item.id] = null
        patch[id] = { alias: item.alias }
      }
    }
    if (Object.keys(patch).length) result[key] = patch
  }
  return result
}
